import type { ContactContent } from '@/core/types';

import { Contact } from '@/containers/blocks/forms';

export default function generate({
  content,
  className,
}: {
  content: ContactContent;
  className?: string;
}) {
  return <Contact title={content.title} subTitle={content.subtitle} className={className} />;
}
